import utilsList from './config/utilsList';

const mainUtilsConfig = utilsList;

export default mainUtilsConfig;
